import LinearConstraints from "./LinearConstraints";

export default LinearConstraints;
